import React from 'react'

import { Box } from '@factorialco/deprecated-design-system'
import { RichTextDisplay, RichTextEditor } from '@factorialco/f0-react/dist/experimental'

import TextArea from 'modules/core/components/TextArea'
import useRichTextEditor from 'modules/core/hooks/useRichTextEditor'
import i18n from 'modules/core/lib/i18n'

type Props = {
  title: string
  comment?: string | null
  readonly: boolean
  onChange: (comment: string) => void
}

export const AnswerRatingComment = React.memo<Props>(({ title, comment, readonly, onChange }) => {
  const { editorConfig, canUseRichTextEditor, loading: loadingRichTextEditor } = useRichTextEditor()

  if (loadingRichTextEditor) return null

  if (!canUseRichTextEditor) {
    return (
      <TextArea
        label={`${title} ${i18n.t('questionnaires.answers.rating.comment_placeholder')}`}
        hideLabel
        placeholder={i18n.t('questionnaires.answers.rating.comment_placeholder')}
        value={comment || ''}
        onChange={onChange}
        readonly={readonly}
      />
    )
  }

  if (readonly) {
    return (
      comment && (
        <Box
          border={{
            all: {
              color: 'grey400',
              width: 's1',
              style: 'solid',
            },
          }}
          borderRadius={{ all: 'abs016' }}
          padding="s16"
          background="grey000White"
        >
          <RichTextDisplay content={comment || ''} />
        </Box>
      )
    )
  }

  return (
    <RichTextEditor
      {...editorConfig}
      title={title}
      onChange={(data) => onChange(data?.value ?? '')}
      placeholder={i18n.t('questionnaires.answers.rating.comment_placeholder')}
      initialEditorState={{
        content: comment || '',
      }}
      maxCharacters={5000}
    />
  )
})

AnswerRatingComment.displayName = 'AnswerRatingComment'
